function collectionSlider(selector, settings) {
  $(selector).slick(settings);
}

$('.product-tab-heading').on('click',function(e){
e.preventDefault();
let selectorForContent = $(this).attr('href'),
selectorSourceParent = $(this).parent('.product-tab'),
SuperParent = $(this).parents('.product-tabs-wrapper');

SuperParent.find('.product-tab').removeClass('active');
$(this).parent('.product-tab').addClass('active');

SuperParent.find('.product-tab-content').removeClass('active');
$(selectorForContent).addClass('active');

});



$(document).on('click','.select-dropdown__button', function(){
	$('.select-dropdown__list').toggleClass('active');
});
$(document).on('click','.select-dropdown__list-item', function(){
	var itemValue = $(this).data('value');
	console.log(itemValue);
	$('.select-dropdown__button span').text($(this).text()).parent().attr('data-value', itemValue);
	$('.select-dropdown__list').toggleClass('active');

    let selectId = $(this).parents('.select-dropdown').next('.product-form__input').find('select').attr('id'),
    select = document.getElementById(selectId);
    
    select.value = itemValue;



    //   select.value = itemValue;
    //   select.value = newValue;

  // Manually trigger the change event
  const changeEvent = new Event('change', {
    bubbles: true, // Ensure the event bubbles up the DOM
    cancelable: true // Allow the event to be cancelable
  });

  // Dispatch the change event
  select.dispatchEvent(changeEvent);
    
});


document.addEventListener('DOMContentLoaded', function() {
    const collectionSections = document.querySelectorAll('.collection');

    collectionSections.forEach(function(section) {
      const tablinks = section.querySelectorAll('.cust__tablinks');
      const tabcontents = section.querySelectorAll('.cust__tabcontent');

      function openCollection(evt, collectionName) {
        // Remove active class from all tabcontents and tablinks
        tabcontents.forEach(tabcontent => tabcontent.classList.remove('active'));
        tablinks.forEach(tablink => tablink.classList.remove('active'));

        // Add active class to current tab and content
        section.querySelector('#' + collectionName).classList.add('active');
        evt.currentTarget.classList.add('active');
      }

      tablinks.forEach(tablink => {
        tablink.addEventListener('click', function(event) {
          const collectionName = this.getAttribute('data-collection');
          openCollection(event, collectionName);
        });
      });

      // Activate the first tab by default
      if (tablinks.length > 0) {
        tablinks[0].click();
      }
    });
  });